<span *ngIf="dot()" class="xp-badge__dot"></span>
<mat-icon *ngIf="icon()" class="xp-badge__icon">{{ icon() }}</mat-icon>
<img *ngIf="iconSrc()" class="xp-badge__image" [src]="iconSrc()" alt="" />
<ng-content></ng-content>
